<template>
  <div id="box" class="error">
    <div class="inner">
      <div class="scrollWrapper">
        <h1 v-html="title" />
        <p v-html="description" class="description" />
        <div class="expandWrapper">
          <img
            v-svg-inline
            class="img"
            src="../assets/imgs/error.svg"
            alt="error"
          />
        </div>
      </div>
      <CustomButton
        :buttonType="'accent'"
        :customButtonTxt="customButton"
        @submit="back"
        v-if="redirectURL && redirectURL.trim() !== ''"
      />
    </div>
  </div>
</template>

<script>
import CustomButton from "../components/customButton.vue";
export default {
  name: "Canceled",
  components: {
    CustomButton,
  },
  props: {
    redirectURL: {
      type: String,
      default: "",
    },
  },
  mounted() {
    localStorage.removeItem("login_challenge");
  },
  computed: {
    title() {
      return this.$t("authorizationError.canceled.title");
    },
    description() {
      return this.$t("authorizationError.canceled.description");
    },
    customButton() {
      return this.$t("customButton.return");
    },
  },
  methods: {
    back() {
      window.location = this.redirectURL;
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
    .img
      +size(100px)
  .wrapper
    +flex(space-between, center, row)
</style>